type MinusIconProps = React.SVGProps<SVGSVGElement>;

const MinusIcon: React.FC<MinusIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    {...props}
  >
    <path d="M19 11.6895H5V13.6895H19V11.6895Z" fill="currentColor" />
  </svg>
);

export default MinusIcon;
